import { render } from "./QLinsDrfTable.vue?vue&type=template&id=5b7275cc&scoped=true"
import script from "./QLinsDrfTable.vue?vue&type=script&lang=js"
export * from "./QLinsDrfTable.vue?vue&type=script&lang=js"

import "./QLinsDrfTable.vue?vue&type=style&index=0&id=5b7275cc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7275cc"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QCheckbox,QTooltip,QIcon,QRadio,QBtn,QTr,QTd,QSelect,QPagination,QInnerLoading,QSpinner,QInput});
